export default {
  category: 'book',
  name: 'Fit For Purpose',
  author: 'Author',
  date: '12/27/22',
  path: '/notes/fit-for-purpose',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-fit-for-purpose-alexei-zheglov.jpg',
  tags: ['Business', 'Management', 'Leadership', 'Product'],
  time: 6,
  rating: 7.1,
  review: '',
  link: 'https://www.amazon.com/Fit-Purpose-Businesses-Satisfy-Customers/dp/0985305118',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
  twosLink: 'https://www.twosapp.com/62e333c1297e980004dababf',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: '',
};
